import InlinePromoListItem from './InlinePromoListItem';

export default InlinePromoListItem;
